export const STATUS_CODE = {
  Success: 200,
  Error: 500,
  ServiceError: 502,
  TokenExpired: 403
};
export const WHITE_LIST = ['sso/login', 'sso/fetch', 'sso/fetchTokenByCode', 'sso/getToken'];
export let HOST = /*#__PURE__*/function (HOST) {
  HOST["BoeInner"] = "democenter."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"";
  HOST["BoeOuterVolc"] = "sdkhub-volc-boe."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"";
  HOST["CnInner"] = "sdkhub."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"";
  HOST["CnOuterVolc"] = "demo.volcvideo.com";
  HOST["CnOuterRtc"] = "rtc.demo.volcengine.com";
  return HOST;
}({});
export const SDKHUB_HOST = Object.values(HOST); // 内网 portal 域名，需要通过 BytedanceSSO 鉴权
export const INNER_PORTAL_HOST = [HOST.CnInner, HOST.BoeInner]; // 对外域名，无需鉴权
export const VOLC_HOST = [HOST.BoeOuterVolc, HOST.CnOuterVolc, HOST.CnOuterRtc];